import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../utils';

interface Step {
  title: string;
  description?: string;
}

interface StepIndicatorProps {
  steps: Step[];
  currentStep: number;
  className?: string;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({
  steps,
  currentStep,
  className,
}) => {
  return (
    <nav className={cn('flex justify-center', className)}>
      <ol className="flex items-center space-x-4 md:space-x-8">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;
          
          return (
            <li key={index} className="flex items-center">
              <div className="flex flex-col items-center">
                <div
                  className={cn(
                    'flex items-center justify-center w-10 h-10 rounded-full border-2 transition-colors',
                    isCompleted && 'bg-blue-600 border-blue-600',
                    isCurrent && 'border-blue-600 bg-white',
                    !isCompleted && !isCurrent && 'border-gray-300 bg-white'
                  )}
                >
                  {isCompleted ? (
                    <Check className="w-5 h-5 text-white" />
                  ) : (
                    <span
                      className={cn(
                        'text-sm font-medium',
                        isCurrent && 'text-blue-600',
                        !isCurrent && 'text-gray-500'
                      )}
                    >
                      {stepNumber}
                    </span>
                  )}
                </div>
                <div className="mt-2 text-center">
                  <p
                    className={cn(
                      'text-sm font-medium',
                      (isCompleted || isCurrent) && 'text-blue-600',
                      !isCompleted && !isCurrent && 'text-gray-500'
                    )}
                  >
                    {step.title}
                  </p>
                  {step.description && (
                    <p className="text-xs text-gray-500 mt-1">
                      {step.description}
                    </p>
                  )}
                </div>
              </div>
              
              {index < steps.length - 1 && (
                <div
                  className={cn(
                    'w-12 md:w-20 h-0.5 ml-4 md:ml-8 transition-colors',
                    stepNumber < currentStep ? 'bg-blue-600' : 'bg-gray-300'
                  )}
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default StepIndicator;